/**
 * Ryan O'Dowd
 * 2023-12-28
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';
import globals from '@utils/globals';

const getStyles = ({windowWidth, windowHeight, noWebHeader}) => {
  const containerHeight = windowHeight - (noWebHeader ? 0 : (Platform.OS === 'web' ? (56 + 8) : 68)); // @TODO: don't hardcode header height
  const containerStyles: any = {
    flexGrow: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  };

  if (Platform.OS === 'web') {
    containerStyles.height = containerHeight;
    containerStyles.maxHeight = containerHeight;
  }

  return {
    container: containerStyles,
    backgroundImageWrapper: {
      flex: 1,
      width: '100%',
      height: '100%',
    },
    backgroundImage: {
      alignSelf: 'flex-end',
      resizeMode: 'cover',
    },
    innerContainer: {
      flex: 1,
      alignItems: 'center',
      width: '100%',
      padding: 0,
      margin: 0,
    },
    innerContainer2: (fullWidth, isLandingPage) => {
      const styles: any = {
        flex: 1,
        width: fullWidth ? '100%' : windowWidth,
        maxWidth: fullWidth ? '100%' : Math.min(windowWidth, globals.maxInnerWidth),
      };

      if (Platform.OS === 'web' && isLandingPage) {
        styles.height = containerHeight;
        styles.maxHeight = containerHeight;
        styles.minHeight = containerHeight;
      }

      return styles;
    },
  };
};

export default getStyles;
